import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class GasStationMpProvider {
  public static async getGasStation(
    gasStationId: number,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetGasStationFillResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetGasStationFillRequest,
      typeof RegionShared.Backend.Responses.GetGasStationFillResponse
    >(RegionShared.Backend.Events.GasStation.GetGasStationFill, {
      gasStationId,
    });
  }

  public static async pay(
    data: typeof RegionShared.Backend.Requests.GasStationFillRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GasStationFillResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GasStationFillRequest,
      typeof RegionShared.Backend.Responses.GasStationFillResponse
    >(RegionShared.Backend.Events.GasStation.GasStationFill, data);
  }
}
